import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const HealthAndSafetyPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  healthSafetyOfficerContact,
  hrContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Health_and_Safety_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Health & Safety Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Statement of Intent</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to ensuring, so far as is reasonably practicable, the health, safety, and welfare of all employees, contractors, visitors, and members of the public affected by our operations. We recognise that health and safety is a fundamental responsibility and an integral part of business success.
      </p>

      <h4 className="section-title">2. Legal Compliance</h4>
      <p className="section-content">
        We shall comply fully with the Health and Safety at Work etc. Act 1974, the Management of Health and Safety at Work Regulations 1999, and all other applicable legislation and approved codes of practice.
      </p>

      <h4 className="section-title">3. Responsibilities</h4>
      <p className="section-content"><strong>Senior Management:</strong> Provide leadership, allocate resources, and ensure that health and safety is prioritised in all business activities.</p>
      <p className="section-content"><strong>Health & Safety Officer:</strong> Oversee implementation, conduct risk assessments, monitor compliance, and report on health and safety performance. Contact: {healthSafetyOfficerContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>Managers and Supervisors:</strong> Ensure team adherence to health and safety procedures and provide training and supervision.</p>
      <p className="section-content"><strong>Employees and Contractors:</strong> Follow all health and safety policies, report hazards and incidents promptly, and participate in training.</p>
      <p className="section-content"><strong>Human Resources:</strong> Support health and safety initiatives and maintain training and incident records. Contact: {hrContact || "[Insert Contact]"}</p>

      <h4 className="section-title">4. Risk Assessment and Control</h4>
      <p className="section-content">
        Regular and systematic risk assessments will be conducted for all operations and work activities to identify hazards, evaluate risks, and implement appropriate control measures in line with the hierarchy of controls.
      </p>
      <ul>
        <li>Identify hazards and assess risks before work commences.</li>
        <li>Implement elimination, substitution, engineering controls, administrative controls, and PPE as necessary.</li>
        <li>Review and update risk assessments regularly or following changes in processes, incidents, or legislation.</li>
      </ul>

      <h4 className="section-title">5. Training and Competence</h4>
      <p className="section-content">
        We are committed to ensuring all employees and contractors are adequately trained and competent to perform their duties safely.
      </p>
      <ul>
        <li>Provide induction training covering health and safety policies and procedures.</li>
        <li>Deliver role-specific training including manual handling, vehicle safety, and equipment operation.</li>
        <li>Maintain training records and schedule refresher training as needed.</li>
      </ul>

      <h4 className="section-title">6. Incident Reporting and Investigation</h4>
      <p className="section-content">
        All accidents, incidents, near misses, and unsafe conditions must be reported promptly.
      </p>
      <ul>
        <li>Use established reporting procedures to document incidents accurately.</li>
        <li>Conduct thorough investigations to identify root causes and implement corrective actions.</li>
        <li>Report notifiable incidents to the Health and Safety Executive (HSE) as required by RIDDOR.</li>
      </ul>

      <h4 className="section-title">7. Workplace Safety and Welfare</h4>
      <p className="section-content">
        The company will provide and maintain safe work environments including:
      </p>
      <ul>
        <li>Safe access and egress, adequate lighting, ventilation, and welfare facilities.</li>
        <li>Safe systems of work including procedures for vehicle operation, loading/unloading, and hazardous substances.</li>
        <li>Provision and maintenance of suitable personal protective equipment (PPE).</li>
      </ul>

      <h4 className="section-title">8. Emergency Procedures</h4>
      <p className="section-content">
        Emergency response plans will be maintained and communicated, covering fire, first aid, spill response, and evacuation procedures.
      </p>
      <ul>
        <li>Conduct regular emergency drills and training.</li>
        <li>Maintain emergency equipment in accessible locations.</li>
        <li>Ensure all personnel are aware of emergency contacts and procedures.</li>
      </ul>

      <h4 className="section-title">9. Health and Wellbeing</h4>
      <p className="section-content">
        We promote employee health and wellbeing by:
      </p>
      <ul>
        <li>Encouraging healthy work-life balance and stress management.</li>
        <li>Supporting access to occupational health services and Employee Assistance Programmes (EAP).</li>
        <li>Implementing measures to prevent workplace violence and harassment.</li>
      </ul>

      <h4 className="section-title">10. Monitoring and Review</h4>
      <p className="section-content">
        Health and safety performance will be monitored through audits, inspections, and consultation with employees. This policy will be reviewed annually or when significant changes occur.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and will comply with the Health & Safety Policy of {clientName || "the Company"}.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now effective.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-700 text-white px-6 py-2 rounded hover:bg-green-800 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default HealthAndSafetyPolicy;
